<mat-selection-list #list *ngIf="auth?.COLUMNS_ARRAY" [formControl]="columnInput">
  <mat-list-option checkboxPosition="before" (click)="onVisible($event,list,item)" [value]="item"
    [selected]="item?.value" *ngFor="let item of auth?.COLUMNS_ARRAY">
    {{selectedTemplate&&selectedTemplate[item?.type]?selectedTemplate[item?.type]:item?.name}}
  </mat-list-option>
</mat-selection-list>